import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { smoothScroll } from "@utils/helpers/smoothScroll";
import { useOnMount } from "@hooks";

const getTopValidationMessageHeight = (validationMessageElementNodeList) => {
  const validationMessageElementArray = [...validationMessageElementNodeList]; // NodeList doesn't support reduce
  const pageYOffset = window.pageYOffset;

  const offsetTop = validationMessageElementArray.reduce((smallestHeightFromTop, validationMessageElement) => {
    const boundingRect = validationMessageElement.getBoundingClientRect();
    const elementOffsetTop = pageYOffset + boundingRect.top;
    return Math.min(elementOffsetTop, smallestHeightFromTop)
  }, Number.MAX_SAFE_INTEGER);

  const offsetTopFound = offsetTop !== Number.MAX_SAFE_INTEGER;
  return offsetTopFound ? offsetTop : 0;
};

const useFormikValidationProdder = () => {
  const {validateForm} = useFormikContext();

  useOnMount(() => {
    (async () => {
      await validateForm();
    })();
  });
};

export const ErrorFocus = ({debug}) => {
  const {isSubmitting, isValidating, errors} = useFormikContext();
  useEffect(() => {
    const keys = Object.keys(errors);
    if (keys.length > 0 && isSubmitting && !isValidating) {
      setTimeout(() => {
        const topValidationOffsetWindowTop = getTopValidationMessageHeight(document.querySelectorAll("[data-validation-scroll-target]"));

        smoothScroll(topValidationOffsetWindowTop - 140);
      }, 50);
    }
  });
  useFormikValidationProdder();

  return <>{debug ? JSON.stringify(errors, null, 2) : ""}</>;
};